<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData" ref="form" label-width="120px">

        <div class="row-title">基本信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="orderId" label="订单ID">
              {{ formData.orderId }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="purchaser" label="采购方">
              {{ formData.purchaserName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="purchaserType" label="采购类型">
              {{ purchaserTypeMap.get(formData.purchaserType) }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.purchaserType === '2'">
            <el-form-item prop="purchaserCompany" label="外销单位">
              {{ formData.purchaserCompany }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderTitle" label="合同标题">
              {{ formData.orderTitle }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderNum" label="合同编号">
              {{ formData.orderNum }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="supplierId" label="供应商">
              {{ formData.supplierName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderPrice" label="付款方式">
              {{ orderPriceMap.get(formData.orderPrice) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderType" label="订单类型">
              {{ orderTypeMap.get(formData.orderType) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="yingfPrice" label="应付金额">
              {{ formData.yingfPrice }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="purchasePrice" label="已付金额">
              {{ formData.purchasePrice }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderState" label="订单状态">
              {{ orderStateMap.get(formData.orderState) }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload readonly v-model="formData.fileList" :maxSize="20"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="row-title">品种规格</div>
        <el-row>
          <el-table :data="formData.specList">
            <!-- <el-table-column prop="" label="采购类型">
              <template v-slot="{ row }">
                {{ purchaseTypeMap.get(row.purchaseType) }}
              </template>
</el-table-column> -->
            <el-table-column prop="specId" label="规格">
              <template v-slot="{ row }">
                {{ row.specName }}
              </template>
            </el-table-column>
            <el-table-column prop="deliveryPrice" :label="formData.orderType === '1' ? '结算单价' : '暂定单价'">
              <template v-slot="{ row }">
                {{ row.deliveryPrice }}
              </template>
            </el-table-column>
            <el-table-column v-if="formData.orderType === '2'" prop="basisPrice" label="基差价格">
              <template v-slot="{ row }">
                {{ row.basisPrice }}
              </template>
            </el-table-column>
            <el-table-column prop="purchaseQuantity" label="订单数量">
              <template v-slot="{ row }">
                {{ row.purchaseQuantity }}
              </template>
            </el-table-column>
            <el-table-column prop="purchaseQuantity" :label="formData.orderType === '1' ? '已提数量' : '已点数量'">
              <template v-slot="{ row }">
                {{ formData.orderType === '1' ? row.ytQuantity : row.ydQuantity }}
              </template>
            </el-table-column>
            <el-table-column prop="purchaseQuantity" :label="formData.orderType === '1' ? '未提数量' : '未点数量'">
              <template v-slot="{ row }">
                {{ formData.orderType === '1' ? (row.purchaseQuantity - row.ytQuantity) : (row.purchaseQuantity -
                  row.ydQuantity) }}
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        <div v-if="deliveryList && deliveryList.length > 0" class="row-title mt15">提货信息</div>
        <el-table v-if="deliveryList && deliveryList.length > 0" size="mini" stripe border :data="deliveryList">
          <el-table-column show-overflow-tooltip min-width="100" label="提货ID" prop="deliveryId"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" label="订单ID" prop="orderId"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" label="合同标题" prop="orderTitle"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" label="合同编号" prop="orderNum"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" label="供应商" prop="supplierName"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" label="发货状态" prop="deliveryState">
            <template v-slot="{ row }">
              {{ deliveryStateMap.get(row.deliveryState) }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip min-width="140" label="提货日期" prop="deliveryDate"></el-table-column>
          <!-- <el-table-column show-overflow-tooltip min-width="140" label="已付价格(元)" prop="paidPrice"></el-table-column> -->
          <el-table-column show-overflow-tooltip min-width="140" label="创建时间" prop="ctime"></el-table-column>

          <el-table-column fixed="right" label="操作" width="120">
            <template v-slot="{ row }">
              <el-button type="text"
                @click="$router.push('/purchaseDelivery/detail?deliveryId=' + row.deliveryId)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
          @current-change="loadDeliveryList">
        </el-pagination>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button v-if="hasApproval && formData.orderState === '1'" type="primary"
                @click="approve">审批</el-button>
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

    <PurchaseOrdersDialog :dataInfo="formData" v-if="approveVisible" @closeDlg="approveVisible = false"
      @successSave="loadData" :showDlg.sync="approveVisible"></PurchaseOrdersDialog>
  </div>
</template>

<script>
import { orderPrice, orderType, purchaseType, ycOrderState, deliveryState, purchaserType } from '@/utils/dict'
import PurchaseOrdersDialog from '@/views/purchaseOrders/PurchaseOrdersDialog.vue'
export default {
  name: 'purchaseOrdersDetail',
  components: {
    PurchaseOrdersDialog
  },
  data() {
    return {
      deliveryStateMap: deliveryState,
      orderPriceMap: orderPrice,
      orderTypeMap: orderType,
      purchaseTypeMap: purchaseType,
      orderStateMap: ycOrderState,
      purchaserTypeMap: purchaserType,
      formData: {
        purchasePrice: '', // 已付金额
        yingfPrice: '', // 应付金额
        orderId: '', // 订单ID
        orderParent: '', // 父级订单id,1表示非子订单
        purchaser: '', // 采购方
        purchaserType: '',
        purchaserCompany: '',
        orderTitle: '', // 合同标题
        orderNum: '', // 合同编号
        supplierId: '', // 供应商ID
        orderPrice: '', // 付款方式1,100%付款2,110%付款
        orderType: '', // 订单类型1一口价订单2基差订单
        orderState: '', // 订单状态1待审核2进行中3已结束4已驳回
        remark: '', // 审批意见
        isDel: 0, // 是否删除，1为删除，0为未删除
        createUserId: '', // 创建人
        ctime: '', // 创建时间
        fileList: [], // 附件列表
        specList: [] // 规格列表
      },
      deliveryList: [],
      page: 1,
      total: 0,
      approveVisible: false
    }
  },
  created() {
    if (this.orderId) {
      this.loadData()
      this.loadDeliveryList()
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    },
    orderId() {
      return this.$route.query.orderId
    }
  },
  methods: {
    approve() {
      this.approveVisible = true
    },
    loadData() {
      this.$axios.get(this.$apis.purchaseOrders.selectYcPurchaseOrderByOrderId, {
        params: { orderId: this.orderId }
      }).then(res => {
        res.fileList = res.fileList ? res.fileList : []
        this.deliveryList = res.deliveryList || []
        res.specList = res.specList.map(item => {
          item.ydQuantity = item.ydQuantity || 0
          item.ytQuantity = item.ytQuantity || 0
          return item
        })
        this.formData = res || {}
      })
    },
    loadDeliveryList() {
      this.$axios.get(this.$apis.purchaseDelivery.selectYcDeliveryByList, {
        params: { orderId: this.orderId }
      }).then(res => {
        this.deliveryList = res.list || []
      })
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;

  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-title {
  font-size: 14px;
  position: relative;
  padding-left: 14px;
  margin-bottom: 20px;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    height: 14px;
    width: 3px;
    background-color: #36f;
    border-radius: 2px;
    transform: translateY(-50%);
  }
}
</style>
